import { Component, Input, OnDestroy, OnInit, Signal } from '@angular/core';
import { ProxyPersonForm } from '../../forms/proxy-person.form';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { SessionService } from '../../../../../../../services/ssession.service';
import { UserDetails } from '../../../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../../../store/selectors/user-details.selectors';
import { Store } from '@ngrx/store';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-proxy-form',
  standalone: true,
  imports: [
    CommonModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    AlertComponent
  ],
  templateUrl: './proxy-form.component.html'
})
export class ProxyFormComponent implements OnInit, OnDestroy {

  @Input()
  public form: ProxyPersonForm | null = null;

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  constructor(private store$: Store) {
  }

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.form?.reset();
  }
}
